<template>
  <div v-if="showLegend" class="crime-legend">
    <div class="legend-header">
      <h4 class="text-sm font-medium text-gray-700 mb-2">Crime Index</h4>
    </div>
    
    <div class="legend-items space-y-1">
      <div 
        v-for="item in legendItems" 
        :key="item.label"
        class="flex items-center space-x-2"
      >
        <div 
          class="w-4 h-4 rounded border border-gray-300"
          :style="{ backgroundColor: item.color }"
        ></div>
        <span class="text-xs text-gray-600">{{ item.label }}</span>
      </div>
    </div>
    
    <div class="legend-note mt-2 pt-2 border-t border-gray-200">
      <p class="text-xs text-gray-500">
        Higher values indicate higher crime risk
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CrimeLegend',
  
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    includeCrime: {
      type: Boolean,
      default: false
    }
  },
  
  computed: {
    showLegend() {
      return this.visible && this.includeCrime;
    },
    
    legendItems() {
      return [
        { color: '#059669', label: 'Very Low (0-20)' },
        { color: '#10B981', label: 'Low (20-50)' },
        { color: '#84CC16', label: 'Below Avg (50-80)' },
        { color: '#EAB308', label: 'Average (80-110)' },
        { color: '#F97316', label: 'Above Avg (110-140)' },
        { color: '#EF4444', label: 'High (140-170)' },
        { color: '#DC2626', label: 'Very High (170+)' }
      ];
    }
  }
}
</script>

<style scoped>
.crime-legend {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  min-width: 160px;
}

.legend-header h4 {
  margin: 0;
}

.legend-items {
  margin: 0;
}

.legend-note {
  margin-top: 8px;
  padding-top: 8px;
}
</style>